<template>
  <div class="box">
    <!-- 头部 -->
    <header class="header">
      <div class="contation">
        <!-- logo -->
           <div class="logo">
          <img
          src="../../assets/logo.png"
          alt=""
        />
        </div>

        <ul class="nav">
          <li>
            <a href="#/home">首页</a>
          </li>
          <li class="active">
            <a style="color: #fff" href="#/counseling">咨询服务</a>
          </li>
          <li><a href="#/AboutUs">关于我们</a></li>
        </ul>
        <div class="moblie">
          <a href="">客服热线: 010-8274334</a>
        </div>
        <div class="consult">
          <p class="service-text">咨询服务</p>
          <p class="null"></p>
          <p class="service-as">Consulting Service</p>
        </div>
      </div>
    </header>
    <div class="main">
      <div class="cloud_main">
      <div class="cloud">
        <h1>云服务那些用户</h1>
        <p class="text">
          云服务作为线上社群电商，大数据分析，线上线下赛事读物领域专家，面向各类型体育场，休闲娱乐场所提供专业一站式信息化解决方案，为政府及相关体育机构提供一站式体育服务平台和体育大数据服务
        </p>
        <ul class="list">
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_03.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_05.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_09.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_11.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_20.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_11.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_21.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_30.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_32.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
          <li>
            <div class="list-img">
              <img src="../../assets/5ac_22.gif" alt="" />
            </div>
            <div class="list-text">
              <p>各省体育局</p>
            </div>
          </li>
        </ul>
      </div>
      </div>
      
      <div class="services">
        <div class="contion">
          <div class="box">
            <img src="../../assets/5ac_28.gif" alt="" />
          </div>
          <div class="box">
            <div>
              <img src="../../assets/5ac_30.gif" alt="" />
              <div class="text">
                <h3>应用培训支持</h3>
                <p>基本应用场景培训，快速熟练操作使用</p>
                <p>定期上线教学，提升管理人员业务技能</p>
                <p>支持移动学习，商户随时随地咨询培训</p>
              </div>
            </div>
          </div>
          <div class="box">
            <img src="../../assets/bjb.png" alt="" />
            <div class="text">
              <h3>专人专项想跟进</h3>
              <p>基本应用场景培训，快速熟练操作使用</p>
              <p>定期上线教学，提升管理人员业务技能</p>
              <p>支持移动学习，商户随时随地咨询培训</p>
            </div>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="contion">
          <h1>我们的服务流程</h1>
          <div class="image">
            <img
              src="../../assets/5a487865eb83e127a152fb22c6f779c_03.gif"
              alt=""
            />
          </div>
        </div>
      </div>
      <Floot></Floot>
    </div>
  </div>
</template>
<script>
import Floot from '@/components/floot'
export default {
  data() {
    return {}
  },
  components: {
    Floot,
  },
  methods: {},
}
</script>

<style>
.box {
  width: 100%;
  background: #EFF0F9;
}

.header {
  height: 456px;
  width: 100%;
  background-image: url('../../assets/bj2.jpg');
  background-size: cover;
}

/*  */
.main {
  height: 1440px;
  width: 100%;
  margin: 0 auto;
}
.main .cloud_main{
  width: 100%;
  height: 700px;
  background: #fff;
}
.main  .cloud {
  height: 700px;
  width: 1200px;
  margin: 0 auto;
 
}
.main .cloud h1 {
  padding-top: 50px;
  text-align: center;
  font-size: 23px;
}
.consult {
  position: absolute;
  top: 100px;
}
.main .cloud .text {
  font-size: 10px;
  color: #999;
  text-align: center;
}
.main .cloud .list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* margin-left: 30px; */
}
.main .cloud .list li {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 220px;
  /* position: relative;*/
  height:230px;
  /* width: 140px; */
  background: #f2f1f7;
  margin-top: 15px;
 /*  margin-left: 35px; */
}
.main .cloud .list li .list-img {
  width: 220px;
  height: 165px;
}
.main .cloud h1 {
  font-size: 40px;
  font-weight: normal;
}
.main .cloud .list li .list-img img {
  border-radius: 8px;
  width: 100%;
}

.main .services {
  height: 700px;
  background: linear-gradient(#eef1fb, #e8f4fb, #fff);
}
.main .services .contion {
  height: 700px;
  width: 1200px;
  margin: 0 auto;
}
.main .services .box {
  width:384px;
  height: 481px;
  margin-left: 12px;
  float: left;
  margin-top: 80px;
 background: #fff;
}
.main .services .box .text {
  margin-left: 20px;
}
.main .services .box .text p {
  font-size: 12px;
  color: #888;
}
.main .services .box .text h3 {
  font-size: 16px;
}
.main .process {
  height: 700px;
  margin: 0 auto;
  background-image: url("../../assets/bj333.png");
}
.main .process .contion {
 padding-top: 150px;
  width: 1200px;
  margin: 0 auto;
}
.main .process .contion h1 {
  width: 1200px;
  font-size: 40px;
  font-weight: normal;
  text-align: center;
}
.main .process .contion .image {
  width: 1197px;
  padding-top: 50px;
  /* padding-left: 100px; */
  /* margin: 0 auto; */
}
.main .process .contion .image img {
   width: 1197px;
   height: 171px;
}
</style>
